import React from 'react'
import { ReactComponent as TipIcon } from '../../../../assets/icons/hint-icon.svg'
import { ReactComponent as TrophyIcon } from '../../../../assets/icons/trophy-large.svg'
import { ReactComponent as SecondPlaceIcon } from '../../../../assets/icons/second.svg'
import { ReactComponent as ThirdPlaceIcon } from '../../../../assets/icons/third.svg'
import { colors } from '../../../../styles/constants'
import { formatCpf, formatListToString } from '../../../../utils/formatters'
import { arraySortAlphabetical } from '../../../../utils/functionalitiesHelper'

export const INFOCARD_DETAILS = {
  title: 'Detalhes dos clientes',
  subtitle: 'O que fazer com essas informações?',
  icon: <TipIcon />,
  customIconColor: colors.yellow.dark
}

export const RANKING_ICONS = [<TrophyIcon />, <SecondPlaceIcon />, <ThirdPlaceIcon />]

export const SAME_DATE_INFO = {
  false: 'no mês',
  true: 'neste mês até o momento'
}

const getPosition = (number) => `${number}º lugar`

export const getClientsDetails = (clientsInfo) => {
  return (
    clientsInfo?.map((clientInfo, index) => {
      return (
        {
          card: {
            title: clientInfo.name,
            subtitle: getPosition(index + 1),
            icon: RANKING_ICONS[index],
            customTitleColor: index === 0 ? colors.cyan.default : null
          },
          cpf: clientInfo.cpf ? formatCpf(clientInfo.cpf) : 'Não preenchido',
          petNames: formatListToString(arraySortAlphabetical(clientInfo.petsNames)),
          amountSpent: clientInfo.billing,
          mostScheduledService: formatListToString(arraySortAlphabetical(clientInfo.mostAttendedServices)),
          mostScheduledServicesAmount: clientInfo.mostAttendedServices.length
        }
      )
    })
  )
}
